export default __webpack_public_path__ + "media/images/tresorerie-vert-c76aa2832e69cbf6474dfc4e33781df6.png";